<script setup>
import { onMounted, ref } from 'vue'
import { Button } from '@components'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import StaffProfileLoader from './StaffProfileLoader.vue'
import StaffProfileDetails from './StaffProfileDetails.vue'
import Main from '../layout/Main.vue'

// import { useRouter, useRoute } from 'vue-router'
// const router = useRouter()
// const route = useRoute()

const state = ref({
    loaded: false
})
onMounted(async () => {
    // $appointments.fetchStaff($appointments.selectedStaff.staff_id)
    state.value.loaded = false
    setTimeout(() => {
        state.value.loaded = true
    }, 100)
})

const close = () => {
    // router.push({ name: 'staff' })
    $appointments.activeStep = 'staff'
}

const selectStaff = () => {
    let staff_id = sessionStorage.getItem('activeStaffId')
    if (!staff_id) return
    // $appointments.setAppointment('staff_id', Number(staff_id))
    $appointments.setAppointment('staff_id', Number(staff_id))
    // router.push({ name: 'date' })
}
</script>

<template>
    <Main slotContentClass="p-0 h-[calc(100%-67px)]">
        <template #content>
            <!-- empty staff profile loader -->
            <StaffProfileLoader v-if="!state.loaded" />

            <!-- staff profile details -->
            <StaffProfileDetails v-if="state.loaded" />
        </template>

        <template #footer v-if="state.loaded">
            <div class="grid grid-cols-2 gap-5">
                <Button @click="close()" type="secondary_gray" size="md" radius="square" class="w-full" :buttonStyle="$customizer.buttonStyleSecondary">Close</Button>
                <Button @click="selectStaff()" type="primary" size="md" radius="square" class="w-full" :buttonStyle="$customizer.buttonStyle">Select {{ $settings.labels.staff?.singular }}</Button>
            </div>
        </template>
    </Main>
</template>